export function comCreateSeal(_opts) {

    let opts = {
        canvas: null, // 生成的canvas dom
        company: "", // 机构名称
        companyTight: false, // 公司名称是否紧凑
        name: "专用章"
    }
    if (typeof _opts == 'object') {
        opts = Object.assign(opts, _opts);
    }
    let context = opts.canvas.getContext('2d');

    context.fillStyle = 'rgba(255, 255, 255, 0)';

    context.globalAlpha = 0.9; // 保留透明度通道

    // 绘制印章边框
    let [width, height, r] = [151, 151, 145];
    // var width = opts.canvas.width / 2;
    // var height = opts.canvas.height / 2;
    context.lineWidth = 6;
    context.strokeStyle = "#f00";
    context.beginPath();
    context.arc(width, height, r, 0, Math.PI * 2);
    context.stroke();
    context.save();

    //画五角星
    if (opts.company.length > 4) {
        context.save();
        context.fillStyle = "#f00";
        context.translate(width, height);//移动坐标原点
        context.rotate(Math.PI + 0);//旋转
        context.beginPath();//创建路径
        let x = Math.sin(0);
        let y = Math.cos(0);
        let dig = Math.PI / 5 * 4;
        for (let i = 0; i < 5; i++) {//画五角星的五条边
            x = Math.sin(i * dig);
            y = Math.cos(i * dig);
            context.lineTo(x * 50, y * 50);
        }
        context.closePath();
        context.stroke();
        context.fill();
        context.restore();
    }

    // 绘制印章名称
    context.font = '22px Helvetica';
    context.textBaseline = 'middle';//设置文本的垂直对齐方式
    context.textAlign = 'center'; //设置文本的水平对对齐方式
    context.lineWidth = 1;
    context.fillStyle = '#f00';
    context.fillText(opts.name, width, height + 73);

    // 绘制印章单位
    context.translate(width, height);// 平移到此位置,
    let count = opts.company.length;// 字数
    let maxCount = 0
    let angle = 0
    if (count > 14) {
        maxCount = 18;
        context.font = '28px Helvetica'
        if (opts.companyTight) {
            angle = 4 * Math.PI / 51;// 字间角度
        } else {
            angle = 4 * Math.PI / (3 * (count - 1));// 字间角度
        }
    } else {
        maxCount = 14;
        context.font = '36px Helvetica'
        if (opts.companyTight) {
            angle = 4 * Math.PI / 39;// 字间角度
        } else {
            angle = 4 * Math.PI / (3 * (count - 1));// 字间角度
        }
    }
    let chars = opts.company.split("");
    let c;

    for (let i = 0; i < count; i++) {
        c = chars[i];// 需要绘制的字符
        if (i == 0) {
            if (opts.companyTight) {
                context.rotate(5 * Math.PI / 6 + angle * ((maxCount - count) / 2));
            } else {
                context.rotate(5 * Math.PI / 6);
            }
        } else {
            context.rotate(angle);
        }
        context.save();
        context.translate(r - 25, 0);// 平移到此位置,此时字和x轴垂直
        context.rotate(Math.PI / 2);// 旋转90度,让字平行于x轴
        context.fillText(c, 0, 5);// 此点为字的中心点
        context.restore();
    }
    // context.translate(width, height);// 平移到此位置,
    let number_count = opts.number.length;
    let number_chars = opts.number.split("");
    let number_angle = 1.16 * Math.PI / (3 * (number_count - 1));// 字间角度
    context.font = '18px Helvetica'
    for (let i = 0; i < number_count; i++) {
        c = number_chars[i];// 需要绘制的字符
        if (i == 0) {
            context.rotate(Math.PI / 1.9);
        } else {
            context.rotate(-number_angle);
        }
        context.save();
        context.translate(r - 20, 0);// 平移到此位置,此时字和x轴垂直
        context.rotate(Math.PI * 1.5);// 旋转90度,让字平行于x轴
        context.fillText(c, 0, 3);// 此点为字的中心点
        context.restore();
    }

    // 仿真效果
    // if (_opts.simulation) {  
    //     // 随机生成裂痕路径； 
    //     // 局部颜色淡化。(渐变)

    //     // 固定位置


    // }
    if (_opts.simulation) {
        // applyVintageMask(_opts) 
        // smear(_opts)  
    }
    // comCreateSeal({canvas:document.getElementById("my_canvas"), company:'安徽互联造物科技有限公司安徽互联造物科技有限公司', name:'测试专用章', number:'98765432115', companyTight:false});
}
// 辅助函数：数值范围限制
const clamp = (val, min = 0, max = 255) => Math.min(max, Math.max(min, val));
// 辅助函数：坐标范围限制
const clampCoord = (val, max) => Math.min(max - 1, Math.max(0, Math.round(val)));
// 辅助函数：线性插值
const lerp = (start, end, t) => start + (end - start) * t;
// 查找印章像素点
const findSealPixel = (width, height, isSealPixel) => {
    for (let tries = 0; tries < 100; tries++) {
        const x = Math.floor(Math.random() * width);
        const y = Math.floor(Math.random() * height);
        if (isSealPixel(x, y)) return [x, y];
    }
    return [-1, -1];
};

// 查找附近有效像素
const findNearbyPixel = (x, y, width, height, isSealPixel) => {
    for (let dx = -4; dx <= 4; dx++) {
        for (let dy = -4; dy <= 4; dy++) {
            const nx = clampCoord(x + dx, width);
            const ny = clampCoord(y + dy, height);
            if (isSealPixel(nx, ny)) return [nx, ny];
        }
    }
    return null;
};
//做旧
export function applyVintageMask(opts) {
    const canvas = opts.canvas; // 定义局部变量避免重复获取
    const ctx = canvas.getContext('2d');
    const width = canvas.width;
    const height = canvas.height;

    // 1. 轻度擦除破损遮罩
    ctx.save();
    ctx.globalCompositeOperation = "destination-out";
    const maskCount = 20 + Math.floor(Math.random() * 15);

    for (let i = 0; i < maskCount; i++) {
        const x = Math.random() * width;
        const y = Math.random() * height;
        const r = Math.random() * 10 + 3;
        const gradient = ctx.createRadialGradient(x, y, 0, x, y, r);
        gradient.addColorStop(0, "rgba(0,0,0,0.4)");
        gradient.addColorStop(1, "rgba(0,0,0,0)");

        ctx.fillStyle = gradient;
        ctx.beginPath();
        ctx.arc(x, y, r, 0, 2 * Math.PI);
        ctx.fill();
    }
    ctx.restore();

    // 2. 轻度噪点
    let imageData = ctx.getImageData(0, 0, width, height);
    let data = imageData.data;

    for (let i = 0; i < data.length; i += 4) {
        if (Math.random() < 0.07) {
            const noise = (Math.random() - 0.5) * 15;
            data[i] = clamp(data[i] + noise);
            data[i + 1] = clamp(data[i + 1] + noise);
            data[i + 2] = clamp(data[i + 2] + noise);
        }
    }
    ctx.putImageData(imageData, 0, 0);

    // // 3. 裂痕效果
    // imageData = ctx.getImageData(0, 0, width, height);
    // data = imageData.data;

    // const crackCount = 5 + Math.floor(Math.random() * 5);
    // ctx.save();
    // ctx.lineCap = "round";
    // ctx.shadowColor = 'rgba(150, 0, 0, 0.5)';
    // ctx.shadowBlur = 1.5;

    // // 辅助函数：检查像素点是否属于印章
    // const isSealPixel = (x, y) => {
    //     const idx = (y * width + x) * 4;
    //     return data[idx + 3] > 50 && data[idx] > 100;
    // };

    // for (let i = 0; i < crackCount; i++) {
    //     let [x, y] = findSealPixel(width, height, isSealPixel);
    //     if (x === -1) continue; // 未找到有效像素点

    //     const segments = 10 + Math.floor(Math.random() * 8);
    //     ctx.beginPath();
    //     ctx.moveTo(x, y);

    //     for (let j = 0; j < segments; j++) {
    //         let nx = clampCoord(x + (Math.random() - 0.5) * 20, width);
    //         let ny = clampCoord(y + (Math.random() - 0.5) * 20, height);

    //         if (!isSealPixel(nx, ny)) {
    //             const found = findNearbyPixel(nx, ny, width, height, isSealPixel);
    //             if (!found) break;
    //             [nx, ny] = found;
    //         }
    //         ctx.lineTo(nx, ny);
    //         [x, y] = [nx, ny];
    //     }

    //     ctx.strokeStyle = `rgba(150, 0, 0, ${0.15 + Math.random() * 0.15})`;
    //     ctx.lineWidth = 1.5 + Math.random() * 1.5;
    //     ctx.stroke();
    // }
    // ctx.restore();

    // 4. 颜色淡化
    imageData = ctx.getImageData(0, 0, width, height);
    data = imageData.data;

    for (let i = 0; i < data.length; i += 4) {
        if (data[i + 3] > 50 && data[i] > 100) {
            const alpha = 0.1 + Math.random() * 0.3;
            data[i] = lerp(data[i], 255, alpha);
            data[i + 1] = lerp(data[i + 1], 255, alpha);
            data[i + 2] = lerp(data[i + 2], 255, alpha);
        }
    }
    ctx.putImageData(imageData, 0, 0);
}


// //印章拖影效果
// function smear(opts) { 
    
// }
// 印章拖影效果
export function smear(opts) {
    const canvas = opts.canvas;
    const ctx = canvas.getContext('2d');
    const width = canvas.width;
    const height = canvas.height;
    
    // 获取当前印章图像数据
    const imageData = ctx.getImageData(0, 0, width, height);
    const data = imageData.data;
    
    // 创建临时缓冲区用于拖影效果
    const tempData = new Uint8ClampedArray(data);
    const tempImageData = new ImageData(tempData, width, height);
    
    // 拖影参数
    const smearLength = 3 + Math.random() * 2; // 拖影长度
    const smearAngle = Math.random() * Math.PI * 2; // 随机方向
    const smearIntensity = 0.4; // 拖影强度
    
    // 计算拖影方向向量
    const dx = Math.cos(smearAngle) * smearLength;
    const dy = Math.sin(smearAngle) * smearLength;
    
    // 遍历所有像素
    for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
            const idx = (y * width + x) * 4;
            
            // 只处理印章像素（红色且不透明）
            if (data[idx + 3] > 200 && data[idx] > 150) {
                // 创建拖影轨迹
                for (let i = 1; i <= smearLength; i++) {
                    const targetX = Math.round(x + dx * (i / smearLength));
                    const targetY = Math.round(y + dy * (i / smearLength));
                    
                    // 确保目标位置在画布内
                    if (targetX >= 0 && targetX < width && targetY >= 0 && targetY < height) {
                        const targetIdx = (targetY * width + targetX) * 4;
                        
                        // 混合颜色（红色通道保持，降低透明度）
                        const alpha = (1 - i / smearLength) * smearIntensity * 255;
                        
                        // 叠加到目标位置
                        tempData[targetIdx] = Math.max(tempData[targetIdx], data[idx]);
                        tempData[targetIdx + 1] = Math.min(tempData[targetIdx + 1], data[idx + 1]);
                        tempData[targetIdx + 2] = Math.min(tempData[targetIdx + 2], data[idx + 2]);
                        tempData[targetIdx + 3] = Math.min(255, tempData[targetIdx + 3] + alpha);
                    }
                }
            }
        }
    }
    
    // 应用拖影效果
    ctx.putImageData(tempImageData, 0, 0);
}
